/**
 * Quantity Selector Module
 */
export class QuantitySelector {
    constructor(container) {
        this.container = container;
        this.input = container.querySelector('input[type="number"]');
        this.min = parseInt(this.input?.getAttribute('min') || '1');
        this.max = parseInt(this.input?.getAttribute('max') || '999');
        this.init();
    }
    init() {
        if (!this.input)
            return;
        const decreaseBtn = this.container.querySelector('[data-action="decrease"]');
        const increaseBtn = this.container.querySelector('[data-action="increase"]');
        decreaseBtn?.addEventListener('click', () => this.decrease());
        increaseBtn?.addEventListener('click', () => this.increase());
        this.input.addEventListener('change', () => this.validate());
        this.input.addEventListener('blur', () => this.validate());
    }
    decrease() {
        const current = parseInt(this.input.value) || this.min;
        if (current > this.min) {
            this.input.value = (current - 1).toString();
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    increase() {
        const current = parseInt(this.input.value) || this.min;
        if (current < this.max) {
            this.input.value = (current + 1).toString();
            this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    validate() {
        let value = parseInt(this.input.value) || this.min;
        value = Math.max(this.min, Math.min(this.max, value));
        this.input.value = value.toString();
    }
}
export default QuantitySelector;
